var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCartSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.361,
    height: 34.459,
    viewBox: "0 0 32.361 34.459",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:2px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(1 1.293)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 3.147,
    cy: 3.147,
    r: 3.147,
    className: "cls-1",
    transform: "translate(18.181 25.873)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 3.147,
    cy: 3.147,
    r: 3.147,
    className: "cls-1",
    "data-name": "Oval",
    transform: "translate(4.545 25.873)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M30.069 0l-8.353 21.677H5.011L0 7.226h27.286",
    className: "cls-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCartSmall);
export default __webpack_public_path__ + "static/media/icon-cart-small.51ec0aa4a783ceb5d2b99cb4b8ff4a00.svg";
export { ForwardRef as ReactComponent };